export const APP_CONFIG = {
  // baseDomain: 'http://127.0.0.1:8200',
  baseDomain: 'https://clapi.tnmlogistics.com',
  mediaDomain: 'https://media.tnmlogistics.com',
  authSetting: {
    tokenName: 'token',
  },
  settings: {
    main_domain: 'https://tnmlogistics.com',
    firebase_prefix: 'tnmlogistics',
    firebase_storage: 'https://firebasestorage.googleapis.com/v0/b/oee-app-cc5a1.appspot.com/o'
  },
  eventBusAction: {
    disableMenuLeft: 'disableMenuLeft',
    disableHeader: 'disableHeader',
    showHideMenuLeft: 'showHideMenuLeft',
    reloadWithdrawalHistories: 'reloadWithdrawalHistories',
    reloadNotification: 'reloadNotification'
  },
  stateKey: {
    authStore: 'authStore',
    commonStore: 'commonStore',
    cartState: 'cartState',
  },
  sqlDateFormat: 'YYYY-MM-DD hh:mm:ss',
};
